module.exports = __webpack_public_path__ + "static/img/pa.8d46ac10.webp";